import { ShopifyBlogService } from './ShopifyBlog';
export const shopifyBlogService = new ShopifyBlogService();
